module.exports = __webpack_public_path__ + "img/musikquiz.70fc24e9.jpg";